import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import avatar from "../avatar.png";
import contactData from "./contactData";
import contactStyles from "./contactStyles";
import { AccountBox, GitHub, EmailOutlined, ForumOutlined, AlternateEmail } from "@mui/icons-material";

const Contact = () => {
  return (
    <Box component="section" sx={contactStyles.section}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={contactStyles.container}
      >
        <Grid container spacing={4} sx={contactStyles.grid}>
          <Grid item xs={12} md={6}>
            <Typography
              variant="overline"
              sx={contactStyles.overline}
            >
              {contactData.subheading}
            </Typography>
            <Typography
              variant="h3"
              sx={contactStyles.heading}
            >
              {contactData.headline}
            </Typography>
            <Typography variant="body1" sx={contactStyles.summary}>
              {contactData.summary}
            </Typography>
            <Box sx={contactStyles.languagesWrap}>
              <Typography
                variant="overline"
                sx={contactStyles.languageLabel}
              >
                Languages
              </Typography>
              <Box sx={contactStyles.chipRow}>
                {contactData.languages.map((language) => (
                  <Chip key={language} label={language} sx={contactStyles.chip} />
                ))}
              </Box>
            </Box>
            <Box sx={{ marginTop: "1.25rem" }}>
              <Button
                variant="outlined"
                startIcon={<AccountBox />}
                href="/impressum.html"
                sx={{ ...contactStyles.actionButton, minHeight: 36, width: "auto" }}
              >
                Impressum und Datenschutz
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={contactStyles.card}
            >
              <Box
                component="img"
                src={avatar}
                alt="Igor Sonntag"
                sx={contactStyles.avatar}
              />
              <Box sx={contactStyles.actions}>
                <Button
                  variant="outlined"
                  startIcon={<EmailOutlined />}
                  disabled
                  sx={{
                    ...contactStyles.actionButton,
                    minHeight: 36,
                    ...contactStyles.actionButtonDisabled,
                  }}
                >
                  {`${contactData.emailParts[0]}@${contactData.emailParts[1]}`}
                </Button>
                <Box sx={contactStyles.actionRow}>
                  <Button
                    variant="outlined"
                    startIcon={<ForumOutlined />}
                    href={contactData.matrixUrl}
                    target="_blank"
                    rel="noreferrer"
                    sx={{ ...contactStyles.actionButton, minHeight: 36, flex: 1, width: "auto" }}
                  >
                    {`Matrix`}
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<AlternateEmail />}
                    href={contactData.mastodonUrl}
                    target="_blank"
                    rel="noreferrer"
                    sx={{ ...contactStyles.actionButton, minHeight: 36, flex: 1, width: "auto", px: 3 }}
                  >
                    {`Mastodon`}
                  </Button>
                </Box>
                <Button
                  variant="outlined"
                  startIcon={<GitHub />}
                  href={contactData.githubWorkUrl}
                  target="_blank"
                  rel="noreferrer"
                  sx={{ ...contactStyles.actionButton, minHeight: 36 }}
                >
                  GitHub (Work)
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<GitHub />}
                  href={contactData.githubPersonalUrl}
                  target="_blank"
                  rel="noreferrer"
                  sx={{ ...contactStyles.actionButton, minHeight: 36 }}
                >
                  GitHub (Personal)
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Contact;
